import { getSettingHelpCenterAIChatbotEntrypoint } from "@faire/help-center-utils/settings/getSettingHelpCenterAIChatbotEntrypoint";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import React from "react";

import {
  ContactUsMainBannerDesktop,
  IContactUsMainBannerProps,
} from "./ContactUsMainBannerDesktop";
import { ContactUsSideBanner } from "./ContactUsSideBanner";
import { NeedMoreHelpBanner } from "./NeedMoreHelpBanner";

export const ContactUsMainBanner: React.FC<IContactUsMainBannerProps> = ({
  borderPosition,
}) => {
  const { isMobile } = useViewport();

  if (getSettingHelpCenterAIChatbotEntrypoint()) {
    return <NeedMoreHelpBanner />;
  }

  return isMobile ? (
    <ContactUsSideBanner isFooter />
  ) : (
    <ContactUsMainBannerDesktop borderPosition={borderPosition} />
  );
};
